import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';
import router from '@/router';
import * as API from '@/api';

function initialState () {
  return {};
}

const state = initialState ();

// actions

const actions = {
  async create (context, payload) {
    return await API.program.create(payload)
  },

  async get (context, payload) {
    return await API.program.get (payload)
    .then((res) => res);
  },

  async delete (context, payload) {

  },

  async list (context, payload) {
    return await API.program.list (payload)
    .then((res) => res.programs);
  },

  async update (context, payload) {
    return await API.program.update (payload)
    .then((res) => res);
  },


};

// getters
const getters = {};

// mutations
const mutations = {};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
